function scoreColor(score) {
  if (score == null) return { text: "text-gray-400", ring: "border-gray-300", bg: "bg-gray-50" };
  if (score >= 80) return { text: "text-green-600", ring: "border-green-400", bg: "bg-green-50" };
  if (score >= 60) return { text: "text-yellow-600", ring: "border-yellow-400", bg: "bg-yellow-50" };
  if (score >= 40) return { text: "text-orange-500", ring: "border-orange-400", bg: "bg-orange-50" };
  return { text: "text-red-600", ring: "border-red-400", bg: "bg-red-50" };
}

// Displays a small circular stability score badge.
// score: 0–100 number, or null when not applicable for current phase.
// size: "sm" (GrowCard) | "md" (GrowDetail header)
export default function StabilityScore({ score, size = "sm" }) {
  const colors = scoreColor(score);

  if (size === "md") {
    return (
      <div className="flex flex-col items-center">
        <div
          className={`w-14 h-14 rounded-full border-2 flex items-center justify-center ${colors.ring} ${colors.bg}`}
        >
          <span className={`text-lg font-bold tabular-nums leading-none ${colors.text}`}>
            {score == null ? "—" : score}
          </span>
        </div>
        <div className="text-xs text-gray-400 mt-1">Stability</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-end shrink-0">
      <div
        className={`w-9 h-9 rounded-full border-2 flex items-center justify-center ${colors.ring} ${colors.bg}`}
      >
        <span className={`text-xs font-bold tabular-nums leading-none ${colors.text}`}>
          {score == null ? "—" : score}
        </span>
      </div>
      <div className="text-xs text-gray-400 mt-0.5">Stability</div>
    </div>
  );
}
